export const MONITORING_EVENT_TYPE = {
  ADD_EXTRA_TIME: "ADD_EXTRA_TIME",
  REMOVE_EXTRA_TIME: "REMOVE_EXTRA_TIME",
  REMOVE_ALL_EXTRA_TIME: "REMOVE_ALL_EXTRA_TIME",
  WORKSHEET_PAUSE: "WORKSHEET_PAUSE",
  WORKSHEET_UNPAUSE: "WORKSHEET_UNPAUSE",
  REOPEN: "REOPEN",
  END: "END",
  RESUME: "RESUME",
  START: "START",
};
